import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useOutsideClickHandler } from "../../../Hooks/useOutsideClick";
import {
  closeModal,
  fetchReturnOrders,
} from "../../../Features/orderManagementSlice";
import { useSelector } from "react-redux";
import CustomButton from "../../../Components/Buttons/CustomButton";
import Cross from "../../../Assets/Modals/closeIcon.svg";
import { showToast } from "../../../Components/Toaster/Toaster";
import { updateReturnOrderStatus } from "../../../lib/utils/apiCalls";
import { useParams } from "react-router-dom";
import { fetchReturnOrderDetails } from "../../../Features/orderDetailsSlice";

const RejectReturnForm = () => {
  const [returnReason, setReturnReason] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const { orderId } = useParams();

  const wrapperRef = useRef(null);
  const dispatch = useDispatch();

  const kebabOrderId = useSelector(
    (state) => state.orderManagement.orderKebab.orderId
  );

  useOutsideClickHandler(wrapperRef, () => {
    handleCloseModal();
  });

  const changeHandler = (e) => {
    setReturnReason(e.target.value);
  };

  const handleCloseModal = () => {
    dispatch(closeModal());
    setReturnReason("");
    setIsLoading(false);
  };

  const isDisabled = !returnReason.trim();

  const handleSubmitAction = async () => {
    setIsLoading(true);

    try {
      const returnOrderId = orderId ?? kebabOrderId;
      const payload = {
        returnStatus: "REJECTED",
        reasonReject: returnReason,
      };

      const response = await updateReturnOrderStatus(returnOrderId, payload);
      if (response?.status === 200) {
        showToast(
          response.data?.data?.message || "Return order rejected successfully ",
          "success"
        );
        dispatch(closeModal());
        dispatch(orderId ? fetchReturnOrderDetails(orderId) : fetchReturnOrders());
      } else {
        showToast("Error in Updating Reject Return.", "error");
      }
    } catch (err) {
      const errorMessage =
        err?.response?.data?.message ||
        "Something went wrong. Please try again.";
      showToast(errorMessage, "error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      ref={wrapperRef}
      className="w-[600px] bg-[#FFFFFF] border border-[#EAEAEA] rounded-[9px] p-4 flex flex-col gap-6"
    >
      <div className="flex flex-col gap-3">
        <div className="flex flex-col gap-2">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <h1 className="font-semibold text-2xl text-[#121212]">
                Reason for Rejection
              </h1>
            </div>

            <button
              onClick={handleCloseModal}
              className="w-11 h-11 flex items-center justify-center"
            >
              <img src={Cross} alt="" />
            </button>
          </div>
        </div>

        <div className="flex flex-col gap-3">
          <div className="flex items-center justify-between">
            <h1 className="font-urmed text-base text-[#121212]">
              Please provide a reason for rejection to inform the shopper. This
              helps maintain trust and transparency.
            </h1>
          </div>

          <textarea
            className="outline-none px-3 py-4 rounded-[9px] bg-[#F5F5F5] border border-[#EAEAEA] placeholder:font-normal placeholder:text-[#666666] text-base font-medium text-[#121212] focus:border-primaryColor resize-none"
            id="reason"
            name="reason"
            rows={10}
            placeholder="write reason here.."
            value={returnReason}
            onChange={changeHandler}
          />
        </div>
      </div>

      <CustomButton
        title="Reject Return"
        variant="red-primary"
        disabled={isDisabled || isLoading}
        loading={isLoading}
        onClick={handleSubmitAction}
      />
    </div>
  );
};

export default RejectReturnForm;
